var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 8.75c-.553 0-1-.447-1-1v-2.75c0-1.654-1.346-3-3-3s-3 1.346-3 3v2.75c0 .553-.447 1-1 1s-1-.447-1-1v-2.75c0-2.757 2.243-5 5-5s5 2.243 5 5v2.75c0 .553-.447 1-1 1z",
    fill: "#90a4ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.75 20h-11.5c-1.24 0-2.25-1.01-2.25-2.25v-8.5c0-1.24 1.01-2.25 2.25-2.25h11.5c1.24 0 2.25 1.01 2.25 2.25v8.5c0 1.24-1.01 2.25-2.25 2.25z",
    fill: "#ffc107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8 0c-2.757 0-5 2.243-5 5v2h2v-2c0-1.654 1.346-3 3-3z",
    fill: "#7d8f97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8 7h-3-2-.75c-1.24 0-2.25 1.01-2.25 2.25v8.5c0 1.24 1.01 2.25 2.25 2.25h5.75z",
    fill: "#dea806"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.452 18.03-.742-1.302 4.836-2.757.742 1.302z",
    fill: "#607d8b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.55 22.031-4.855-2.739.737-1.307 4.854 2.74z",
    fill: "#607d8b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.875 14.923-3.165 1.805.719 1.262.003-.005.05.029 2.393-1.365z",
    fill: "#546d79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.432 17.985-.003.005-.734 1.302 3.18 1.794v-1.722l-2.393-1.35z",
    fill: "#546d79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15 20c-1.103 0-2-.896-2-2s.897-2 2-2 2 .896 2 2-.897 2-2 2z",
    fill: "#2196f3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m15 16c-1.103 0-2 .896-2 2s.897 2 2 2z",
    fill: "#1d83d4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m22 16c-1.103 0-2-.896-2-2s.897-2 2-2 2 .896 2 2-.897 2-2 2z",
    fill: "#2196f3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m22 24c-1.103 0-2-.896-2-2s.897-2 2-2 2 .896 2 2-.897 2-2 2z",
    fill: "#2196f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1d83d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 12c-1.103 0-2 .896-2 2s.897 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 20c-1.103 0-2 .896-2 2s.897 2 2 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureShare);
export default __webpack_public_path__ + "static/media/secure-share.dbab57c114d85f78c0b22a8ae2d554f9.svg";
export { ForwardRef as ReactComponent };